import { Reveal, Overline } from "@/components/Reveal";
import { Cpu, Megaphone, Headset, LayoutGrid } from "lucide-react";

const SOLUTION_IMG = "https://images.pexels.com/photos/8452381/pexels-photo-8452381.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const PILLARS = [
  { icon: LayoutGrid, title: "CRM y plataforma", desc: "El sistema completo para captar, gestionar y convertir prospectos ya está montado. Usted opera, no programa." },
  { icon: Megaphone, title: "Pauta en Meta Ads", desc: "Campañas centralizadas y optimizadas que alimentan su territorio con demanda calificada de forma constante." },
  { icon: Cpu, title: "Contenido y producto", desc: "La oferta educativa, los materiales y la experiencia del cliente final vienen listos y probados." },
  { icon: Headset, title: "Soporte centralizado", desc: "Un equipo detrás resuelve la operación técnica y comercial. Usted se enfoca en crecer, no en apagar incendios." },
];

export function Solution() {
  return (
    <section id="solution" data-testid="solution-section" className="relative py-24 sm:py-32 bg-ivory">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <Reveal>
            <div className="relative">
              <img src={SOLUTION_IMG} alt="Infraestructura digital abstracta" className="w-full h-[520px] object-cover" />
              <div className="absolute inset-0 ring-1 ring-inset ring-midnight/10" />
              <div className="absolute inset-0 bg-gradient-to-t from-midnight/70 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <div className="font-serif text-2xl font-bold text-ivory">Todo el negocio, sin metros cuadrados.</div>
              </div>
            </div>
          </Reveal>

          <div>
            <Reveal>
              <Overline>La solución</Overline>
              <h2 className="font-serif text-4xl sm:text-5xl font-bold tracking-tight text-midnight mt-6 leading-[1.05]">
                El modelo Kairós Learning: 100% digital.
              </h2>
              <p className="font-sans text-lg font-light leading-relaxed text-midnight/60 mt-6">
                Recibe una franquicia educativa lista para operar sobre infraestructura digital.
                Sin renta, sin remodelación, sin inventario. La inversión va al negocio, no al ladrillo.
              </p>
            </Reveal>

            <div className="grid sm:grid-cols-2 gap-px bg-midnight/10 mt-10 border border-midnight/10">
              {PILLARS.map((p, i) => (
                <Reveal key={p.title} delay={i * 0.08} className="bg-white">
                  <div className="p-7 h-full">
                    <p.icon className="w-7 h-7 text-crimson" strokeWidth={1.5} />
                    <h3 className="font-serif text-xl font-semibold text-midnight mt-4">{p.title}</h3>
                    <p className="font-sans text-sm font-light text-midnight/60 mt-2 leading-relaxed">{p.desc}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
